import * as LabelPrimitive from '@radix-ui/react-label';
import type { ComponentPropsWithoutRef, ElementRef } from 'react';
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import type { ITheme } from '../../utils/theme';
import { theme } from '../../utils/theme';
import { getLabelColor } from '../input/helper-functions/colors';

interface IStyledInputLabel {
  $hasError: boolean;
  theme: ITheme;
}

const InputLabel = forwardRef<
  ElementRef<typeof LabelPrimitive.Root>,
  ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & IStyledInputLabel
>(({ ...props }, ref) => <StyledInputLabel ref={ref} {...props} />);
InputLabel.displayName = LabelPrimitive.Root.displayName;

export default InputLabel;

const StyledTypographyLabelPrimitive = styled(LabelPrimitive.Root)(
  theme.typography.bodySm2
);

const StyledInputLabel = styled(StyledTypographyLabelPrimitive)`
  ${({ $hasError, theme }: IStyledInputLabel) => css`
    display: inline-block;
    color: ${getLabelColor($hasError, theme)};
    text-transform: none;
    text-align: left;
    ::first-letter {
      text-transform: uppercase;
    }
  `}
`;
